import { Application } from '../../../webapi/useApplication';
import { Client } from '../../../webapi/useClient';
import { ClientEmailData } from '../../../../api/getClientEmail';
import { ClientPhoneData } from '../../../../api/getClientPhone';
import { LatestLoan } from '../../../webapi/useLatestLoan';
import digestMessage from '../hash';

export interface IIdentifyEvent {
  type: 'identify';
  timestamp: number;
  client?: Client;
  application?: Application;
  email?: ClientEmailData;
  phone?: ClientPhoneData;
  client_loan?: LatestLoan | null;
  hasEmail: boolean;
  hasApplication: boolean;
  getHash(): Promise<string>;
}

export default class IdentifyEvent implements IIdentifyEvent {
  readonly type = 'identify' as const;

  readonly timestamp: number;

  readonly client?: Client;

  readonly application?: Application;

  readonly email?: ClientEmailData;

  readonly phone?: ClientPhoneData;

  readonly client_loan?: LatestLoan | null;

  constructor({
    client,
    application,
    email,
    phone,
    client_loan,
  }: {
    client?: Client;
    application?: Application;
    email?: ClientEmailData;
    phone?: ClientPhoneData;
    client_loan?: LatestLoan | null;
  }) {
    this.timestamp = new Date().getTime();
    if (client) {
      this.client = client;
    }
    if (application) {
      this.application = application;
    }
    if (email) {
      this.email = email;
    }
    if (phone) {
      this.phone = phone;
    }
    if (client_loan !== undefined) {
      this.client_loan = client_loan;
    }
  }

  get hasEmail() {
    if (this.email?.email) {
      return true;
    }
    return false;
  }

  get hasApplication() {
    return !!this.application;
  }

  async getHash() {
    return digestMessage(this.email?.email ?? '');
  }
}
